import { CircleMinus, CirclePlus } from 'lucide-react'
import './zoomControl.css'

type ZoomControlProps = {
  zoom: number
  setZoom: (zoom: number) => void
  min?: number
  max?: number
}

const ZoomControl = ({ zoom, setZoom, min = 1, max = 5 }: ZoomControlProps) => {
  const handleZoomOut = () => {
    setZoom(Math.max(min, Math.round((zoom - 0.1) * 10) / 10))
  }

  const handleZoomIn = () => {
    setZoom(Math.min(5, Math.round((zoom + 0.1) * 10) / 10))
  }

  const handleZoomChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setZoom(Math.min(max, Math.max(min, parseFloat(e.target.value))))
  }
  const percent = Math.max(0, Math.min(100, ((zoom - min) / (max - min)) * 100))

  return (
    <div className="p-m flex items-center justify-center pt-0">
      <div className="gap-s px-s flex w-[360px] items-center rounded-lg bg-gray-100 py-[14px]">
        <button
          aria-label="Zoom out"
          onClick={handleZoomOut}
          className="p-0 outline-none"
        >
          <CircleMinus size={20} />
        </button>
        <div className="relative w-full">
          <div className="absolute left-0 top-1/2 h-1 w-full -translate-y-1/2 rounded-full bg-gray-300" />
          <div
            className="absolute left-0 top-1/2 h-1 -translate-y-1/2 rounded-full bg-gray-900"
            style={{ width: `${percent}%` }}
          />
          <input
            type="range"
            min={min}
            max={max}
            step={0.01}
            value={zoom}
            onChange={handleZoomChange}
            className="zoom-slider relative z-10 w-full appearance-none bg-transparent"
            aria-label="Zoom"
          />
        </div>
        <button
          aria-label="Zoom in"
          onClick={handleZoomIn}
          className="outline-none"
        >
          <CirclePlus size={20} />
        </button>
      </div>
    </div>
  )
}

export default ZoomControl
